export default __webpack_public_path__ + "pro98d97d.png";